import { CustomNumberField } from "components/shared/form";
import VehicleOwnership from "components/shared/vehicleOwnership";
import { featureModuleTypesEnum } from "helpers/enums";
import { truckNumber } from "helpers/validators";
import React from "react";

const Body = ({
    renderField,
    renderSelect,
    renderFuelTanks,
    renderCheckbox,
    setValue,
    setCustomNumberMode,
    data = {},
    renderMechanic,
    renderСolumnDispatcher,
    ...props
}) => {
    const {
        number,
        brandTypeId,
        typeId,
        carrying,
        volume,
        ownershipType,
        ownershipBasisDocuments,
        trackerId,
        logistId,
        transportColumnId,
        comment,
        needsMaintenanceComment,
        needsUrgentMaintenance,
        isInRefuelingSyncList,
        availableFeatureModules,
        refuelingSettings,
        accessPermitIds,
        organizationName,
        ownershipDisabled,
    } = props;
    const useCustomNumber = !!data.useCustomNumber;

    return (
        <>
            <CustomNumberField
                number={number}
                numberValidator={truckNumber}
                onCustomNumberChange={setCustomNumberMode}
                renderField={renderField}
                useCustomNumber={useCustomNumber}
            />
            {renderSelect(brandTypeId)}
            {renderSelect(typeId)}
            <VehicleOwnership
                carrying={carrying}
                data={data}
                disabled={ownershipDisabled}
                organizationName={organizationName}
                ownershipBasisDocuments={ownershipBasisDocuments}
                ownershipType={ownershipType}
                renderField={renderField}
                renderSelect={renderSelect}
                setValue={setValue}
                volume={volume}
            />
            {renderSelect(logistId)}
            {renderSelect(trackerId)}
            {renderSelect(transportColumnId)}
            {!refuelingSettings.hideRefuelingPlanning &&
                availableFeatureModules.includes(featureModuleTypesEnum.RefuelingPlanning) &&
                renderCheckbox(isInRefuelingSyncList)}
            {renderMechanic()}
            {renderСolumnDispatcher()}
            {renderField(comment)}
            {renderField(needsMaintenanceComment)}
            {renderCheckbox(needsUrgentMaintenance)}
            {renderSelect(accessPermitIds)}
            {renderFuelTanks()}
        </>
    );
};

export default Body;
